import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { EMutualFundFlow } from "../MutualFund";
const NoMandate = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement("span", { className: "DMSanN_14_400 mb-2 txt-label-gray" }, "Mandate")),
            React.createElement(Col, { lg: 12, className: "d-flex justify-content-center align-items-center" },
                React.createElement("div", null,
                    React.createElement("div", { className: "errorsection nomandate-errormsg text-center" },
                        React.createElement(Errormsg, { icon: "edel-icon-emtpy_icon", msg: "No Mandates available." }),
                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80 mt-3 DMSansNormal_12_400", value: "Create New Mandate", onClick: () => props.setNewMandate(EMutualFundFlow.NEWMANDATE) })))))));
};
export default NoMandate;
